import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />

      <div style={{
        flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#f9fafb", padding: "60px 20px"
      }}>
        <div style={{ textAlign: "center", maxWidth: "600px" }}>

          {/* Icône ancre */}
          <div style={{
            width: "120px", height: "120px", borderRadius: "50%", backgroundColor: "#f0fdfa",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 30px", border: "3px solid #0d9488"
          }}>
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="1.5">
              <circle cx="12" cy="5" r="2" />
              <line x1="12" y1="7" x2="12" y2="19" />
              <path d="M6 11H3a9 9 0 009 9 9 9 0 009-9h-3" />
              <line x1="8" y1="13" x2="6" y2="11" />
              <line x1="16" y1="13" x2="18" y2="11" />
            </svg>
          </div>

          <div style={{
            fontSize: "100px", fontWeight: "800", color: "#e5e7eb",
            lineHeight: "1", marginBottom: "10px", letterSpacing: "-4px"
          }}>
            404
          </div>

          <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1f2937", marginBottom: "12px" }}>
            Page introuvable
          </h1>

          <p style={{ fontSize: "16px", color: "#6b7280", marginBottom: "10px", lineHeight: "1.7" }}>
            Oops ! Il semblerait que vous ayez dérivé en dehors de nos eaux.
          </p>
          <p style={{ fontSize: "14px", color: "#9ca3af", marginBottom: "40px" }}>
            La page que vous cherchez n'existe pas ou a été déplacée.
          </p>

          <div style={{ display: "flex", gap: "15px", justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate(-1)} style={{
              display: "flex", alignItems: "center", gap: "8px",
              padding: "13px 24px", backgroundColor: "white", color: "#374151",
              border: "1px solid #e5e7eb", borderRadius: "8px",
              fontSize: "14px", fontWeight: "600", cursor: "pointer"
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
              </svg>
              Retour
            </button>

            <Link to="/" style={{
              display: "flex", alignItems: "center", gap: "8px",
              padding: "13px 24px", backgroundColor: "#0d9488", color: "white",
              borderRadius: "8px", textDecoration: "none",
              fontSize: "14px", fontWeight: "600"
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Accueil
            </Link>

            <Link to="/catalogue" style={{
              display: "flex", alignItems: "center", gap: "8px",
              padding: "13px 24px", backgroundColor: "white", color: "#0d9488",
              border: "2px solid #0d9488", borderRadius: "8px",
              textDecoration: "none", fontSize: "14px", fontWeight: "600"
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              Explorer le catalogue
            </Link>
          </div>

          {/* Liens rapides */}
          <div style={{ marginTop: "50px", padding: "24px", backgroundColor: "white", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
            <p style={{ fontSize: "13px", fontWeight: "600", color: "#6b7280", marginBottom: "14px" }}>
              Pages populaires
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
              {[
                { label: "Catalogue", to: "/catalogue" },
                { label: "RFQ", to: "/rfq" },
                { label: "Exposants", to: "/exposants" },
                { label: "À propos", to: "/a-propos" },
                { label: "Contact", to: "/contact" }
              ].map(link => (
                <Link key={link.to} to={link.to} style={{
                  padding: "7px 14px", backgroundColor: "#f0fdfa", color: "#0d9488",
                  borderRadius: "6px", textDecoration: "none", fontSize: "13px", fontWeight: "600"
                }}>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default NotFound;